
document.addEventListener("DOMContentLoaded", function () {
  let selector = document.querySelector('.product-card__variant-selector');

  if (selector) {
    selector.addEventListener('change', handle);
    handle({ currentTarget: selector }); // ✅ Initial setup
  } else {
    console.warn('.product-card__variant-selector not found.');
  }

 function handle(e) {
  const wrapper = e.currentTarget; // the element with the event listener
  console.log(wrapper, 'this');

  // Get selected option values
  const selectedOptions = Array.from(wrapper.querySelectorAll('select')).map(el => el.value);
  console.log(selectedOptions, 'selectedOptions');

  // Get product variant JSON data
  const productDataEl = wrapper.querySelector('[type="application/json"]');
  if (!productDataEl) {
    console.warn('Product data not found');
    return;
  }

  let variantData;
  try {
    variantData = JSON.parse(productDataEl.textContent);
  } catch (err) {
    console.error('Failed to parse product data JSON', err);
    return;
  }

  // Find the matching variant
  const currentVariant = variantData.find(variant =>
    variant.options.every((option, index) => option === selectedOptions[index])
  );

  if (!currentVariant) {
    console.warn('No matching variant found');
    return;
  }

  console.log(currentVariant, '✅ Matching variant');

  const productForm = wrapper.closest('.product-card')?.querySelector('.product-sample_form');
  const input = productForm?.querySelector('input[name="id"]');
  const currencyFormat = window.moneyformat;

  // Update price
  const priceEl = document.querySelector('.sample-sale-price .new-price');
  if (priceEl && typeof formatMoney === 'function') {
    priceEl.innerText = formatMoney(currentVariant.price, currencyFormat);
  }

  // Update image
  const img_smpl = document.querySelector('.sample_prt_img');
  if (img_smpl && currentVariant.featured_image?.src) {
    img_smpl.src = currentVariant.featured_image.src;
  }

  // Update button state
  const crt_btn = document.querySelector('.sample-prt-adct');
  const crt_btn_text = crt_btn?.querySelector('span');
  if (crt_btn && crt_btn_text) {
    if (!currentVariant.available) {
      crt_btn_text.innerText = 'Sold out';
      crt_btn.disabled = true;
    } else {
      crt_btn_text.innerText = 'Add To Cart';
      crt_btn.disabled = false;
    }
  }

  // Update hidden input
  if (input) {
    input.value = currentVariant.id;
  } else {
    console.warn('Hidden input[name="id"] not found.');
  }
}


function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "{{amount}}";

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) return 0;

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}



const cartButton = document.querySelector('.sample-prt-adct');

  if(cartButton){
cartButton.addEventListener('click', checkCart);
}

async function checkCart(e) {
  try {
    e.preventDefault();
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cartData = await cartResponse.json();
    console.log(cartData, 'cartData');

    const targetId = 7857190568006;
    const productForm = document.querySelector('.product-sample_form');
    const variantId = productForm.querySelector('input[name="id"]').value;

    const matchingItems = cartData.items.filter(item => item.product_id === targetId);
    const totalQuantity = matchingItems.reduce((sum, item) => sum + item.quantity, 0);
    const matchingVariant = matchingItems.some(item => item.variant_id == variantId);

    const submitButton = productForm.querySelector("button[type='submit']");
    const button = productForm.querySelector('.sample-prt-adct');
    const message = productForm.querySelector('.sample-notification');

    if (totalQuantity >= 5) {
      message.innerText = "You reached your limit";
      button.after(limitMessage);
        message.classList.remove('hidden');
    } else {
      if (matchingVariant) {
        message.innerText = "You can't add the same variant twice";
        message.classList.remove('hidden');
      } else {
        message.classList.add('hidden');
        submitButton.dispatchEvent(new Event('change', { bubbles: true }));
        submitButton.click();        
      }
    }

    console.log(`Total quantity of product ID ${targetId}:`, totalQuantity);
  } catch (error) {
    console.error('Error checking cart contents:', error);
  }
}



});

//Define of the discount class
class DiscountManager extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  connectedCallback() {
    // can be used if you need to re-init after being attached
  }

  init() {
    const applyBtn = this.querySelector("#apply-discount-btn");
    const clearBtn = this.querySelector("#clear-discount-btn");
    this.discountCodeError = this.querySelector("#discount-code-error");
    this.discountCodeWrapper = this.querySelector("#applied-discount-code .applied-discount-code-wrapper");
    this.discountCodeValue = this.querySelector("#applied-discount-code .applied-discount-code-value");
    this.discountCodeInput = this.querySelector("#discount-code-input");
    this.totalCartSelector = this.querySelector(".cart__subtotal .money");
    const open_block = this.querySelector('.cart-accordion-title');

    if (open_block) {
      open_block.addEventListener("click", (e) => {
        e.preventDefault();
        this.openDiscout();
      });
    }

    if (applyBtn) {
      applyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.applyDiscount(this.discountCodeInput.value);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.clearDiscount();
        this.updateCartdrawerElement();
      });
    }
  }

  openDiscout() {
    const elementDiscount = this.querySelector('.discount_manager');
    // const elementDiscIcon = this.querySelector('.discount_arrow_icon');
    // if (elementDiscIcon) elementDiscIcon.classList.toggle('rotate-180');
    if (elementDiscount) elementDiscount.classList.toggle('active');
  }

  async clearDiscount() {
    try {
      this.discountCodeValue.innerHTML = "";
      this.discountCodeError.innerHTML = "";
      await this.clearLocalStorage();

      // Shopify endpoint to clear discount
      await fetch("/discount/CLEAR");
      await this.updateCartdrawerElement();
    } catch (error) {
      console.error("Error clearing discount:", error);
    }
  }

  async clearLocalStorage() {
    if (this.discountCodeWrapper) this.discountCodeWrapper.style.display = "none";
    if (this.totalCartSelector && localStorage.discountCode) {
      const localStorageData = JSON.parse(localStorage.discountCode);
      if (localStorageData?.totalCart) {
        this.totalCartSelector.innerHTML = localStorageData.totalCart;
      }
    }
    localStorage.removeItem("discountCode");
  }

  async applyDiscount(code) {
    const applyBtn = this.querySelector("#apply-discount-btn");

    if (!code || code.trim() === "") {
      this.discountCodeError.innerHTML = "Please enter a discount code.";
      return;
    }

    if (applyBtn) {
      applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
      applyBtn.style.pointerEvents = "none";
    }

    try {
      const discountApplyUrl = `/discount/${encodeURIComponent(code.trim())}?v=${Date.now()}`;
      const response = await fetch(discountApplyUrl);

      if (response.ok) {
        // Discount applied via Shopify
        if (this.discountCodeWrapper) this.discountCodeWrapper.style.display = "inline";
        if (this.discountCodeError) this.discountCodeError.innerHTML = "";
        if (this.discountCodeValue) this.discountCodeValue.innerHTML = code.toUpperCase();

        // Store code locally
        localStorage.setItem("discountCode", JSON.stringify({ code: code.trim() }));

        // Refresh cart drawer
        setTimeout(() => this.updateCartdrawerElement(), 500);
      } else {
        // Invalid discount
        this.clearLocalStorage();
        if (this.discountCodeError) this.discountCodeError.innerHTML = "Invalid or expired coupon code.";
      }
    } catch (error) {
      console.error("Error applying discount:", error);
      if (this.discountCodeError) this.discountCodeError.innerHTML = "An error occurred. Please try again.";
    } finally {
      if (applyBtn) {
        applyBtn.innerHTML = "APPLY";
        applyBtn.style.pointerEvents = "all";
      }
    }
  }

 async updateCartdrawerElement() {
  try {
    const cartDrawer = document.querySelector('.cart-drawer');
    if (!cartDrawer) {
      console.error('cartDrawer element not found in DOM.');
      return;
    }

    let cartHeader = cartDrawer.querySelector('.cart-drawer__inner');

    fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then((response) => {
        const wgHtml = new DOMParser().parseFromString(response, 'text/html');
        const newInnerCartDrawer = wgHtml.querySelector('.cart-drawer__inner');

        if (cartHeader && newInnerCartDrawer) {
          cartHeader.innerHTML = newInnerCartDrawer.innerHTML;
        } else {
          console.error('Could not find .cart-drawer__inner in fetched HTML.');
        }
      })
      .catch((error) => {
        console.error('Error updating cart drawer:', error);
      });
  } catch (error) {
    console.error('Failed to update cart drawer:', error);
  }
}
}


customElements.define("discount-manager", DiscountManager);
